import dynamic from 'next/dynamic';

const SellRequestsGrid = dynamic(() =>
  import('./SellRequestsGrid/SellRequestsGrid')
);

const AddSellRequestsModal = dynamic(() =>
  import('./AddSellRequestsModal/AddSellRequestsModal')
);

const SellRequestsForm = dynamic(() =>
  import('./SellRequestsForm/SellRequestsForm')
);

const SellRequestsFiltersModal = dynamic(() =>
  import('./SellRequestsFiltersModal/SellRequestsFiltersModal')
);

const SellRequestsListContent = dynamic(() =>
  import('./SellRequestsListContent')
);
const UploadSellRequestDocument = dynamic(() =>
  import('./UploadSellRequestDocument/UploadSellRequestDocument')
);
const SellRequestsFilters = dynamic(() =>
  import('./SellRequestsFilters/SellRequestsFilters')
);

export {
  SellRequestsGrid,
  AddSellRequestsModal,
  SellRequestsForm,
  SellRequestsFiltersModal,
  SellRequestsListContent,
  UploadSellRequestDocument,
  SellRequestsFilters,
};
